module.exports = __webpack_public_path__ + "img/logo-metalco.472532e6.png";